'use strict';

export function initMenuExpand() {

  // Submenu toggle - POUZE na kliknutí
  const submenuParents = document.querySelectorAll('.menu--main .menu-item--expanded');

  submenuParents.forEach(parent => {
    const button = parent.querySelector('button');
    const submenu = parent.querySelector('.submenu');

    // Kliknutí na tlačítko submenu
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Zavřít ostatní otevřená submenu
      submenuParents.forEach(otherParent => {
        if (otherParent !== parent) {
          const otherSubmenu = otherParent.querySelector('.submenu');
          const otherArrow = otherParent.querySelector('.submenu-arrow');
          otherSubmenu.classList.remove('is-open');
          otherArrow.classList.remove('rotate-180');
        }
      });

      // Toggle aktuálního submenu
      submenu.classList.toggle('is-open');
      button.classList.toggle('rotate-alert');
    });
  });

  // Zavřít submenu při kliknutí mimo
  document.addEventListener('click', function(e) {

    if (!e.target.closest('.submenu-parent')) {
      submenuParents.forEach(parent => {
        const submenu = parent.querySelector('.submenu');
        const arrow = parent.querySelector('.submenu-arrow');
        submenu.classList.add('hidden');

        if(arrow) {
          arrow.classList.remove('rotate-180');
        }
      });
    }
  });
}
